export const analyticsId = {
  OPEN_YOUNG_CARD_STEP_1_VIEW: 'OPEN_YOUNG_CARD_STEP_1_VIEW',
  OPEN_YOUNG_CARD_STEP_2_VIEW: 'OPEN_YOUNG_CARD_STEP_2_VIEW',
  OPEN_YOUNG_CARD_STEP_3_VIEW: 'OPEN_YOUNG_CARD_STEP_3_VIEW',
  OPEN_YOUNG_CARD_STEP_4_VIEW: 'OPEN_YOUNG_CARD_STEP_4_VIEW',
  OPEN_YOUNG_CARD_STEP_5_VIEW: 'OPEN_YOUNG_CARD_STEP_5_VIEW',
  OPEN_YOUNG_CARD_STEP_6_VIEW: 'OPEN_YOUNG_CARD_STEP_6_VIEW',
  OPEN_YOUNG_CARD_WIZARD_ERROR: 'OPEN_YOUNG_CARD_WIZARD_ERROR',
  OPEN_YOUNG_CARD_WIZARD_SUCCESS: 'OPEN_YOUNG_CARD_WIZARD_SUCCESS',
};

const commonFields = productName => ({
  sectionFamily: 'banking',
  sectionCategory: 'products',
  sectionName: 'cards',
  serviceType: 'productContracting',
  interactionType: 'funnel',
  processType: 'contractingCard',
  detalleProceso: productName,
  productName,
});

export const catalogue = {
  [analyticsId.OPEN_YOUNG_CARD_STEP_1_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_precontractual',
    pageName: '/contractingCard/step1/precontractual',
    processStep: 'step1',
    processDetail: 'precontractual',
  }),
  [analyticsId.OPEN_YOUNG_CARD_STEP_2_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_holder_data',
    pageName: '/contractingCard/step2/holderData',
    processStep: 'step2',
    processDetail: 'holderData',
  }),
  [analyticsId.OPEN_YOUNG_CARD_STEP_3_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_linked_account',
    pageName: '/contractingCard/step3/linkedAccount',
    processStep: 'step3',
    processDetail: 'linkedAccount',
  }),
  [analyticsId.OPEN_YOUNG_CARD_STEP_4_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_card_selection',
    pageName: '/contractingCard/step4/cardSelection',
    processStep: 'step4',
    processDetail: 'cardSelection',
  }),
  [analyticsId.OPEN_YOUNG_CARD_STEP_5_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_shipment',
    pageName: '/contractingCard/step5/shipment',
    processStep: 'step5',
    processDetail: 'shipment',
  }),
  [analyticsId.OPEN_YOUNG_CARD_STEP_6_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_confirmation',
    pageName: '/contractingCard/step6/confirmation',
    processStep: 'step6',
    processDetail: 'confirmation',
  }),
  [analyticsId.OPEN_YOUNG_CARD_WIZARD_ERROR]: ({ productName, errorMessage }) => ({
    ...commonFields(productName),
    event_name: 'step_error',
    pageName: '/contractingCard/error',
    processStep: 'error',
    errorCategory: 'requestError',
    errorDescription: errorMessage,
  }),
  [analyticsId.OPEN_YOUNG_CARD_WIZARD_SUCCESS]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_success',
    pageName: '/contractingCard/success',
    processStep: 'success',
  }),
};
